// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'plus-between-right-column';

export const Component = () => (
  <path d='M0 5.885h.958V22.6h7.854v-9.052h1.006V22.6h13.745V5.885h.958v17.673H0V5.885Zm15.709 0v3.928h-1.006V5.885h-3.927v-.958h3.927V1h1.006v3.927h3.927v.958h-3.927Z' />
);

export const viewBox = '0 0 25 25';
